import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  useProjectTemplateProjectPhase,
  ProjectTemplateProjectPhase,
} from 'data/templates/projects';
import {
  Breadcrumb,
  BreadcrumbButton,
  ContentWrapper,
  HeaderSection,
  HeaderSectionWrapper,
  Card as StyledCard,
  StatusIndicator,
  Wrapper,
  DetailViewTitleInput,
} from '../../../../commons';
import {
  ProjectPhaseMoreActions,
  useTemplateProjectPhaseCommonActions,
} from '../../commons';

const Card = styled(StyledCard)`
  min-height: 50vh;
  width: 688px;
`;

const CardTitle: FC<{
  projectPhaseId: number;
}> = ({ projectPhaseId }) => {
  const projectPhase: ProjectTemplateProjectPhase =
    useProjectTemplateProjectPhase(projectPhaseId);
  const { onUpdateName } = useTemplateProjectPhaseCommonActions(projectPhase);

  return projectPhase ? (
    <>
      <Breadcrumb>
        <Breadcrumb.Item>
          <BreadcrumbButton>
            <FormattedMessage id="phase" />
          </BreadcrumbButton>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Wrapper>
        <StatusIndicator
          progress={0}
          status={{
            label: 'To do',
            group: 1,
            color: 'blue',
          }}
        />
        <ContentWrapper>
          <HeaderSectionWrapper>
            <HeaderSection>
              <DetailViewTitleInput
                value={projectPhase.projectPhaseName}
                updateValue={onUpdateName}
              />
            </HeaderSection>
            <ProjectPhaseMoreActions projectPhaseId={projectPhaseId} />
          </HeaderSectionWrapper>
        </ContentWrapper>
      </Wrapper>
    </>
  ) : (
    <></>
  );
};

export const ProjectTemplatePhaseDetailView: FC<{
  projectPhaseId: number;
}> = ({ ...rest }) => {
  return <Card bordered={false} type="inner" title={<CardTitle {...rest} />} />;
};
